export const NETWORK_PORT_MIN = 1;
export const NETWORK_PORT_MAX = 65535;
